import { defineMessages } from 'react-intl'

export default defineMessages({
  empty: {
    id: 'containers.Languages.empty',
    defaultMessage: 'No match',
  },
  queryPlaceholder: {
    id: 'containers.Languages.queryPlaceholder',
    defaultMessage: 'Start typing to filter languages..',
  },
  metaTitle: {
    id: 'containers.Languages.meta.title',
    defaultMessage: '+150 native languages | VoiceArchive',
  },
  metaDescription: {
    id: 'containers.Languages.meta.descriptions',
    defaultMessage:
      "Browse and filter more than 150 languages in VoiceArchive's voicebank. Missing a language? Just reach out!",
  },
})
